import React from "react";
import { Card } from "react-bootstrap";

import * as Bs from "react-icons/bs";
import * as Gi from "react-icons/gi";

import "./aboutUs.css";

export default function AboutUs({ aboutUsData }) {
  const aboutImage = "./images/dark-leaves-2.jpg";
  return (
    <Card
      data-aos="fade-up"
      className="p-0"
      id="about"
      style={{
        borderRadius: "25px",
        boxShadow: "-10px 20px 30px rgba(0, 0, 0, 0.1)",
        border: "none",
        margin: "5%",
      }}
    >
      <Card.Body className="p-0 ">
        <div className="row p-0">
          <div className="col-md-7 p-5">
            <div>
              <div
                className="p-0 fs-4 text-uppercase"
                style={{ color: "var(--primary)" }}
              >
                About
              </div>
              <div className="p-0 fs-1 fw-bold">Who we are</div>
              <hr
                style={{
                  width: "10%",
                  borderTop: "6px solid var(--primary)",
                  opacity: "1",
                  borderRadius: "10px",
                }}
              />
              <p>{aboutUsData.aboutUs}</p>

              <div className="row row-cols-1">
                <div className="col p-4 about-us-div">
                  <div className="d-flex align-items-center">
                    <Gi.GiArcheryTarget
                      size={75}
                      color={"var(--primary"}
                      className="me-4"
                    />
                    <div>
                      <div className="fw-bold fs-5">Mission</div>
                      <div className="text-muted">{aboutUsData.mission}</div>
                    </div>
                  </div>
                </div>
                <div className="col p-4 about-us-div">
                  <div className="d-flex align-items-center">
                    <Bs.BsRocketTakeoff
                      size={75}
                      color={"var(--primary"}
                      className="me-4"
                    />
                    <div>
                      <div className="fw-bold fs-5">Vision</div>
                      <div className="text-muted">{aboutUsData.vision}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-5 p-0 about-us-img">
            <img
              src={aboutImage}
              alt="About us"
              style={{
                objectFit: "cover",
                overflow: "hidden",
                borderTopRightRadius: "25px",
                borderBottomRightRadius: "25px",
              }}
            />
          </div>
        </div>
      </Card.Body>
    </Card>
  );
}
